import { Typography } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { AsyncAutocomplete } from 'components/core-ui/AsyncAutocomplete'
import { getExistingAddresses } from 'components/location/api'
import { LocationFormItem } from 'components/location/interfaces'
import { FormikProps } from 'formik'
import { useNotification } from 'hooks'

interface ExistingAddressProps {
  formik: FormikProps<LocationFormItem>
}

const ExistingAddress = (props: ExistingAddressProps) => {
  const { formik } = props

  const { showNotification } = useNotification()

  const { data: existingAddressesOptions } = getExistingAddresses(showNotification)

  return (
    <>
      <Grid xs={6} item>
        <AsyncAutocomplete
          variant="outlined"
          name="locationAddress"
          label="Location"
          value={{
            value: formik.values.locationAddress?.id,
            label: formik.values.locationAddress?.name
          }}
          options={existingAddressesOptions || []}
          onChange={value =>
            formik.setFieldValue('locationAddress', {
              id: value.value,
              name: value.label,
              completeAddress: value.completeAddress
            })
          }
          error={!!formik.errors.locationAddress?.id}
          helperText={formik.errors.locationAddress as string}
          required
        />
      </Grid>
      <Grid xs={12} item>
        <Typography variant="medium">{formik.values.locationAddress?.completeAddress}</Typography>
      </Grid>
    </>
  )
}

export default ExistingAddress
